export default __webpack_public_path__ + "static/media/override.94b6fca1.png";